import * as details from '../modules/details';

const init = {
    isLoading: false,
    hasError: false,
    errorCode: null,
    errorText: null
};

function detailsReducer(state = init, action) {
    let newState = Object.assign({}, state);

    if (action.type === 'REQUEST_CUSTOMER_DETAILS') {
        const { data, tokens } = action.data;

        details.customerDetails({ ...data }, { ...tokens });
        newState = {
            ...state,
            ...action.data,
            isLoading: true
        };
    }

    if (action.type === 'RECEIVE_CUSTOMER_DETAILS') {
        newState = {
            ...state,
            ...action.data,
            isLoading: false
        };
    }

    if (action.type === 'CUSTOMER_DETAILS_CALL_FAILURE') {
        newState = {
            ...state,
            isLoading: false,
            hasError: true,
            errorCode: action.data.status,
            errorText: action.data.statusText
        };
    }

    return newState;
}

export default detailsReducer;



// WEBPACK FOOTER //
// ./src/reducers/details.js